import { createSlice } from '@reduxjs/toolkit';
import { Branch } from 'common/model/Branch';
import { NullUndefined } from 'common/model/NullUndefined';

interface BranchState {
  branches?: NullUndefined<Branch[]>;
}

const initialState: BranchState = {};

const branchSlice = createSlice({
  name: 'branch',
  initialState,
  reducers: {
    setBranches: (state, { payload }: { payload: NullUndefined<Branch[]> }) => {
      state.branches = payload;
    },
  },
});

export const branchActions = branchSlice.actions;
export const branchReducer = branchSlice.reducer;
